export default {
  required: '此项为必填项',
  email: '请输入有效的邮箱地址',
  phone: '请输入有效的手机号码',
  minLength: '最少需要 {min} 个字符',
  maxLength: '最多允许 {max} 个字符',
  number: '请输入数字',
  integer: '请输入整数',
  positive: '请输入正数',
  url: '请输入有效的网址',
  passwordMismatch: '两次输入的密码不一致',
  passwordWeak: '密码强度不足',
};
